export default "__VITE_ASSET__BAoijFFE__"